import { document } from './globals';

/**
 * Wait until body is defined before injecting link.
 * This ensures a non-blocking load in IE11.
 *
 * @param  {Function} cb Ready callback.
 * @return {void}
 */
export default function onBodyReady(cb) {

	if (document.body) {
		cb();
		return;
	}

	setTimeout(() => {
		onBodyReady(cb);
	});
}
